<template>
	<div>
		<div class="operation-box f-cb" style="width: 100%;text-align: left;">
			<!-- <span class="f-fl" style="line-height: 40px;">共有 <i style="color: red;">31</i>个码</span> -->
			<!-- <div class="f-fr"> -->
			<el-input placeholder="请输入企业名称" @keyup.enter.native="inquire" v-model.trim="precisecontext" class="input-with-select"
			 style="width: 300px;">
				<el-button slot="append" icon="el-icon-search" @click="inquire"></el-button>
			</el-input>
			<el-button type="primary" style="margin-left:20px ;" @click="$router.push({ path: 'companyEdit' })"> 新建企业名片</el-button>
			<!-- </div> -->
		</div>
		<section class="result-box">
			<el-table :data="tableData" style="width: 100%;min-height: 480px;text-align: center;" v-loading="Loading">
				<el-table-column prop="yardImg" label="封面图" width="80">
					<!-- <template slot-scope="scope">
						<img src="../assets/imgs/pic02.jpg" alt="封面图" style="width: 50px;cursor: pointer;" @click="yardIncident(scope.row)" />
					</template> -->
					<template slot-scope="scope">
						<el-image :src="scope.row.pic_name" :preview-src-list="scope.row.pic_name" :lazy="true" style="width: 40px; height: 40px;" />
					</template>
				</el-table-column>
				<!-- <el-table-column align="center" property="iconUrl" label="图片">
					<template slot-scope="scope">
					  <img :src="scope.row.picUrl" width="40">
					</template>
				</el-table-column> -->
				<el-table-column prop="name" label="企业名称" minWidth="150">
				</el-table-column>
				<!-- <el-table-column prop="idcode" label="唯一编码">
				</el-table-column> -->
				<el-table-column prop="analynum_today" label="今日扫描次数">
				</el-table-column>
				<el-table-column prop="analynum_total" label="累计扫描次数">
				</el-table-column>
				<el-table-column prop="createtime" label="创建时间 ">
				</el-table-column>
				<el-table-column prop="type" label="操作 " min-width="300px" header-align="center">
					<template slot-scope="scope">
						<!--{{scope.row.operationList}}-->
						<!-- <el-button size="mini" v-for="(item,index) in scope.row.operationList" plain style="margin-top: 10px;margin-left: 0;margin-right: 10px;" :type="item.isGray?'info':'primary'" @click="handleDelete(scope.$index, scope.row,item.operationType,item.isGray)" :key="index">{{item.operation}}</el-button> -->
						<el-button size="mini" plain type="primary" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="preview(scope.row)">预览</el-button>
						<el-button size="mini" plain type="primary" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="showCode(scope.row)">二维码</el-button>
						<el-button size="mini" plain type="primary" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="toEdit(scope.row)">编辑</el-button>
						<el-button size="mini" v-if="scope.row.status==1" type="primary" plain style="margin-top: 10px;margin-left: 0;margin-right: 10px;"	 @click="isEnable(scope.row.id,0)">禁用</el-button>
						<el-button size="mini" v-else type="warning" plain style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="isEnable(scope.row.id,1)">启用</el-button>
					</template>
				</el-table-column>
			</el-table>
		</section>
		<div class="pagination-box">
			<el-pagination background layout="prev, pager, next,slot,total,sizes" :total="pagination.total" :page-size="10"
			 prev-text=" 上一页 " :page-sizes="[10,20]" next-text="下一页" @prev-click="prev" @next-click="next" @current-change="current" @size-change="size">

			</el-pagination>
		</div>
		<!-- yulan -->
		<el-dialog :visible.sync="yardImgshow" class="previewBox2" width="360px">
			<img src="../assets/imgs/phone-top.png" alt="">
			<div class="phoneBox">
				<div class="cover-img1 border-bottom white-bj cor">
					<img :src="form.posterSrc" style="width: 100%;">
					<h3>{{form.comName}}</h3>
				</div>
				<div class="big-box11 cor" style="text-align: left;" v-for="(item,index) in comList">
					<div class="company-js border-bottom white-bj padding16">
						<h3><i></i><a class="previewA" @click="gotoUrl(item.href);">{{item.title}}</a></h3>
						<div class="com-img mat16" v-show="item.pic_name">
							<img :src="item.pic_name">
						</div>
						<div class="com-text mat061">
							<font>{{item.content}}</font>
						</div>
					</div>
				</div>
				<div class="big-box21 cor" style="text-align: left;" v-if="form.mobilePhone || form.comWebsite || form.comAddress || form.wbName">
					<div class="company-js contect border-bottom white-bj padding16">
						<h3><i></i><a class="previewA">联系方式</a></h3>
						<ul class="contect-list">
							<li v-show="form.mobilePhone">
								<label>联系电话：</label>
								<a class="previewA">{{form.mobilePhone}}</a>
							</li>
							<li v-show="form.comWebsite">
								<label>公司官网：</label>
								<a class="previewA">{{form.comWebsite}}</a>
							</li>
							<li v-show="form.comAddress">
								<label>公司地址：</label>
								<a class="previewA">{{form.comAddress}}</a>
							</li>
							<li v-show="form.wbName">
								<label>微博名称：</label>
								<a class="previewA">{{form.wbName}}</a>
							</li>
						</ul>
					</div>

				</div>
				<div class="big-box31 cor" style="text-align: left;" v-if="form.kfPhone || form.kfQQ">
					<div class="company-js service white-bj border-bottom padding16">
						<h3><i></i>
							<a class="previewA">客服信息</a>
						</h3>
						<ul class="contect-list">
							<li>
								<label>客服电话：</label>
								<a class="previewA">{{form.kfPhone}}</a>
							</li>
							<li>
								<label>客服QQ：</label>
								<a class="previewA">{{form.kfQQ}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<img src="../assets/imgs/phone-bottom.png" alt="">
		</el-dialog>
		<el-dialog :visible.sync="mzShow" class="codeBox" width="320px">
			<div class="ma-box" v-show="codeShow">
				<img :src="codeSrc">
			</div>
			<div class="line"></div>
			<h3>选择码制</h3>
			<div class="popou-choose">
				<el-checkbox-group v-model="checkList" @change="onMzchange">
				   <el-checkbox label="汉信码"></el-checkbox>
				   <el-checkbox label="龙贝码"></el-checkbox>
				   <el-checkbox label="GM码"></el-checkbox>
				   <el-checkbox label="QR码"></el-checkbox>
				</el-checkbox-group>
			</div>
			<h3>选择码标</h3>
			<div class="popou-choose">
				<el-select v-model="mbVal" placeholder="请选择" @change="onMbchange">
					<el-option v-for="item in mbList" :key="item.identification_ID" :label="item.identification" :value="item.identification_ID">
					</el-option>
				</el-select>
			</div>
			<div class="btn-long" style="margin: 20px 0;">
				<!-- <input type="button" onclick="zipDownloads();" value="打包下载码图"> -->
				<el-button type="warning" @click="downloadCode">打包下载码图</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		Loading
	} from 'element-ui';
	import debounce from "lodash/debounce";

	export default {
		name: 'companyCard',
		data() {
			return {
				tableData: [],
				pagination: {
					total: 0,
					present: 1,
					size: 10
				},
				Loading: false,
				precisecontext: '',
				yardImgshow: false,
				form: {
					posterSrc: '',
					comName: '',
					mobilePhone: '',
					comWebsite: '',
					comAddress: '',
					wbName: '',
					kfPhone: '',
					kfQQ: ''
				},
				comList: [],
				phoneList: [{ // 移动电话列表
						id: 0,
						phoneNum: '13012345678'
					},
					{
						id: 1,
						phoneNum: '13012345789'
					}
				],
				faxList: [{ // 传真列表
						id: 0,
						faxNum: '12345'
					},
					{
						id: 1,
						faxNum: '23456'
					}
				],
				emailList: [{ // 电子邮箱列表
					id: 0,
					email: '123@qq.com'
				}, {
					id: 1,
					email: '13012345678@163.com'
				}],
				qqList: [{
					id: 0,
					qqNum: '12345678'
				}, {
					id: 1,
					qqNum: '22345856'
				}],
				wbList: [{
					id: 0,
					wbName: 'user01'
				}, {
					id: 1,
					wbName: 'user02'
				}],
				addList: [{
					id: 1,
					address: '01'
				}],
				mzShow: false, // 二维码弹窗
				mbList: [],
				mbVal: '',
				identification_ID: '',
				codeShow: false,
				codeSrc: '',
				checkList: ['QR码'],
				mtList: '',
				idcode: '',
			}
		},
		mounted() {
			this.$store.commit('resistopen')
			//           this.$store.state.resistshow =true;
			//			console.log(this.$store.state.resistshow )
		},
		created() {
			this.getCompany();
		},
		methods: {
			getCompany() {
				this.Loading = true;
				this.$http.get(this.$api + '/lightapp/getCompanyCodeList', {
					params: {
						searchKeys: this.precisecontext,
						pageIndex: this.pagination.present,
						pageSize: this.pagination.size
					}
				}).then(res => {
					if (res.body.result === 1) {
						// console.log(res.data.entity)
						res.data.entity.content.forEach((item,index)=> {
							if(!item.pic_name) {
								item.pic_name = require("../assets/imgs/pic_8.png")
							}
						})
						this.tableData = res.data.entity.content
						this.pagination.total = res.data.entity.totalElements;
					} else {
						this.tableData = [];
						this.pagination.total = 0;
					}
					this.Loading = false;
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})
			},
			inquire: debounce(function() {

				this.getCompany();

			}, 200),
			prev(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.getCompany();

			},
			next(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.getCompany();

			},
			current(val) {
				this.pagination.present = val;
				this.getCompany();
			},
			size(val) {
				this.pagination.size = val
				this.getCompany()
			},
			preview(row) {
				console.log(row.idcode)
				this.yardImgshow = true
				this.getIdcodeInfo(row.idcode)
			},
			getIdcodeInfo(idcode) {	// 详情
				this.$http.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: idcode
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity.moduleList)
						var that = this
						this.form = {
							posterSrc: res.body.entity.moduleList.head.cover?res.body.entity.moduleList.head.cover:require("../assets/imgs/pic_8.png"),
							comName: res.body.entity.moduleList.head.name,
							mobilePhone: res.body.entity.moduleList.contact.phone,
							comWebsite: res.body.entity.moduleList.contact.href,
							comAddress: res.body.entity.moduleList.contact.address,
							wbName: res.body.entity.moduleList.contact.microblog,
							kfPhone: res.body.entity.moduleList.service.phone,
							kfQQ: res.body.entity.moduleList.service.qq
						}
						res.body.entity.moduleList.company.forEach((item,index)=>{
							if(!item.pic_name){
								item.pic_name = require('../assets/imgs/pic_10.png')
							} else if(item.pic_name == '0') {
								item.pic_name = ''
							}
						})
						this.comList = res.body.entity.moduleList.company
						
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				
				})
			},
			// 获取码标列表
			getMblist() {
				this.$http.get(this.$api + '/lightapp/getIdentificationList', {
					params: {
						idcode: this.idcode,
					}
				}).then(res => {
					if (res.body.result === 1) {
						console.log(res.body.entity)
						this.mbList = []
						res.body.entity.forEach((item,index)=> {
							this.mbList.push({
								identification_ID: item.identification_ID,
								identification: item.identification
							})
							// this.checkList.push(item.)
						})
						this.mbVal = res.body.entity[0].identification_ID
						this.identification_ID = res.body.entity[0].identification_ID
						if(this.identification_ID) {
							this.createCode()	// 生成码图
						}
						
					} else {
						this.identification_ID = ''
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				
				})
			},
			createCode() {
				this.$http.get(this.$api + '/CodeImage/createCodeImage', {
					params: {
						idcode: this.idcode,
						identificationID: this.identification_ID
					}
				}).then(res => {
					if (res.body.result === 1) {
						// console.log(res.body.entity)
						this.mtList = res.body.entity.imgList
						this.codeSrc = res.body.entity.baseUrl + res.body.entity.imgList.QR码
						this.codeShow = true
						// console.log(this.codeSrc)
					} else {
						// this.tableData = [];
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');
				})
			},
			// 监听码标下拉切换
			onMbchange(val) {
				this.identification_ID = val
				this.createCode()
			},
			// 监听码制选择
			onMzchange() {
				console.log(this.checkList)
			},
			showCode(row) {
				this.idcode = row.idcode
				this.getMblist()
				this.mzShow = true
			},
			downloadCode() {		// 打包下载码图
				console.log(this.checkList,'选中的码制')
				console.log(this.mtList,'码图列表')
				var fileNames_arr = []
				if(this.checkList.length > 0 && this.mtList) {
					this.checkList.forEach((item,index)=> {
						for(let key in this.mtList) {
							if(item == key) {
								fileNames_arr.push(this.mtList[item])
							}
						}
					})
				} else {
					this.$message.warning('请先选择码制！')
					return false
				}
				var fileNames = fileNames_arr.join(',')
				console.log(fileNames)
				console.log(this.$api+ "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode")
				location.href = this.$api+ "/CommonMethod/ZipDownloadsBatch/?fileNames=" + fileNames + "&filePath=CreateCode";
			},
			toEdit(row) { // 跳转编辑
				// console.log(row.idcode)
				this.$router.push({
					name: 'companyEdit',
					// query: {
					// 	idcode: row.idcode
					// }
				})
				this.$setCookie('idcode',row.idcode)
			},
			isEnable(id,status) {
				this.$http.post(this.$api + '/lightapp/lightAppIsEnable', {
					id: id,
					isEnable: status
				}).then(res => {
					if (res.body.result === 1) {
						this.$message.success(res.body.message);
						this.getCompany()
					} else {
						this.$message.error(res.body.message);
					}
				})
			},
			gotoUrl: function(url) {
				if (url) {
					console.log(url)
					window.open(url, "_blank");
					// window.location.href = url
				}
			}
		},
		destroyed() {
			//			console.log(this.$store.state.resistshow )

			this.$store.commit('resistDestroy')
		},
	}
</script>
<style>
	.contect-list li label {
	    width: 80px !important;
	}
	.previewBox2 .el-dialog {
		background: transparent !important;
		box-shadow: none !important;
	}

	.previewBox2 .el-dialog__body {
		/* width: 100%;
		box-sizing: border-box !important; */
		padding: 0 !important;
		font-size: 16px !important;
	}

	.previewBox2 .phoneBox {
		margin-top: -3px;
		background-color: #fff;
		height: 500px;
		/* padding-top: 4%; */
		overflow: -moz-scrollbars-none;
		scrollbar-width: none;
		-ms-scroll-chaining: chained;
		-ms-content-zooming: zoom;
		-ms-scroll-rails: none;
		-ms-content-zoom-limit-min: 100%;
		-ms-content-zoom-limit-max: 500%;
		-ms-scroll-snap-type: proximity;
		-ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
		-ms-overflow-style: none;
		overflow: auto;
	}

	.phoneBox::-webkit-scrollbar {
		display: none;
		width: 0;
	}

	.previewBox2 .el-dialog__headerbtn {
		right: -50px !important;
		background-color: #fff !important;
		border-radius: 50%;
		padding: 3px 4px !important;
	}

	.person-cover {
		width: 100%;
		height: 230px;
		/* background: url(../assets/imgs/pic_9.png) no-repeat center; */
		background-size: cover;
		/* position: relative; */
	}

	.person-cover2 {
		height: 260px;
	}

	.person-head {
		width: 90px;
		height: 90px;
		border-radius: 90px;
		position: absolute;
		top: 75px;
		left: 20px;
		overflow: hidden;
	}

	.person-head img {
		width: 90px;
		height: 90px;
	}

	.person-head2 {
		position: absolute;
		left: 50% !important;
		margin-left: -45px;
		top: 20px !important;
	}

	.person-head3 {
		position: absolute;
		left: inherit;
		right: 20px !important;
		top: 75px;
	}

	.person-text {
		position: absolute;
		top: 84px;
		left: 130px;
		text-align: left;
	}

	.person-text2 {
		text-align: center;
		position: absolute;
		top: 120px;
		left: 50%;
		margin-left: -110px;
	}

	.person-text2 p {
		width: 220px !important;
	}

	.person-text3 {
		position: absolute;
		left: inherit;
		top: 84px;
		right: 130px !important;
		text-align: right;
	}

	.person-text h3 {
		color: #FFFFFF;
		font-size: 18px;
		font-weight: normal;
	}

	.person-text p {
		color: #FFFFFF;
		margin-top: 6px;
		width: 190px;
	}

	.contact-list {
		margin: 0;
		padding: 0;
	}

	.contact-list li {
		box-sizing: border-box;
		padding: 14px 20px;
		border-top: 1px solid #E1E1E1;
		text-align: left;
	}

	.contact-box {
		position: relative;
	}

	.re-position {
		position: relative;
		top: -10px;
		left: 40px;
	}

	.com-list2 input {
		margin-top: -5px;
		width: 250px !important;
	}

	.com-list3 input {
		width: 200px !important;
	}

	.com-list3 label {
		width: 60px !important;
	}

	.com-list3 .adress-icon {
		display: inline-block;
		color: #298BEF;
	}

	.com-list3 .adress-icon i {
		display: inline-block;
		width: 12px;
		height: 16px;
		background: url(../assets/imgs/address-1.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 3px;
		margin-left: 2px;
		margin-right: 2px;
	}

	.com-list4 label {
		display: inline-block;
		float: left;
		width: 90px !important;
		text-align: right;
	}

	.com-list4 textarea {
		display: inline-block;
		float: left;
		width: 260px;
		height: 100px;
		border: 1px solid #E1E1E1;
	}

	.add-icon {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/add-2.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 10px;
	}

	.sc {
		display: inline-block;
		width: 22px;
		height: 22px;
		background: url(../assets/imgs/minus_03.png) no-repeat;
		background-size: 100%;
		position: relative;
		top: 5px;
		left: 12px;
	}

	.com-list2 li label {
		display: inline-block;
		width: 80px;
		text-align: right;
		color: #666666;
	}

	.show-position img {
		display: inline-block;
		margin-right: 3px;
	}

	.mb-phone {
		width: 360px;
	}

	.phone-top {
		height: 43px;
	}

	.phone-topCompany {
		height: 43px;
	}

	.cover-img img {
		width: 358px;
	}

	.codeBox .line {
		width: 100%;
		height: 1px;
		background-color: #E1E1E1;
	}

	.codeBox h3 {
		text-align: center;
		font-size: 16px;
		font-weight: normal;
		margin: 14px 0;
	}
</style>

<style lang="scss">
	.result-box {
		.el-table {
			.cell {
				text-align: center;
			}
		}
	}
</style>
